import nl from "./nl";
import en from "./en";

const CATALOGS = { nl, en };
const DEFAULT_LOCALE = "nl";

/** Resolve dotted key "auth.email" -> string. Falls back to key if missing. */
export function t(key, locale = DEFAULT_LOCALE) {
  const cat = CATALOGS[locale] || CATALOGS[DEFAULT_LOCALE];
  const val = key.split(".").reduce((acc, part) => (acc ? acc[part] : undefined), cat);
  if (val === undefined) {
    // Fallback to Dutch catalog before returning key
    const fb = key.split(".").reduce((acc, part) => (acc ? acc[part] : undefined), nl);
    return fb !== undefined ? fb : key;
  }
  return val;
}

export default t;
